import { render, staticRenderFns } from "./PeptideContentCalculator.vue?vue&type=template&id=4f3cd33b&scoped=true"
import script from "./PeptideContentCalculator.vue?vue&type=script&lang=js"
export * from "./PeptideContentCalculator.vue?vue&type=script&lang=js"
import style0 from "./PeptideContentCalculator.vue?vue&type=style&index=0&id=4f3cd33b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3cd33b",
  null
  
)

export default component.exports